module.exports = __webpack_public_path__ + "static/img/face6.07adc9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face6.jpg
// module id = LYTk
// module chunks = 0